<template>
  <div>
<!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/base/index' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>对账管理</el-breadcrumb-item>
    </el-breadcrumb>
    <!--列表-->
    <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;margin-top: 30px;">
      <el-table-column prop="dz_date" align="center" label="对账日期"  width="130">
        <template slot-scope="scope">
          <i class="el-icon-time"></i>
          <span style="margin-left: 10px">{{ scope.row.dz_date }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="wxpaynum" align="center" label="微信支付订单数量" width="80">
      </el-table-column>
      <el-table-column prop="wxpaymoney" align="center" label="微信支付金额" width="100">
      </el-table-column>
      <el-table-column prop="wxrefnum" align="center" label="微信退费数量" width="80">
      </el-table-column>
      <el-table-column prop="wxrefmoney" align="center" label="微信退费金额" width="100">
      </el-table-column>
      <el-table-column prop="wxybpaynum" align="center" label="微信医保现金支付数量" width="100">
      </el-table-column>
      <el-table-column prop="wxybpaymoney" align="center" label="微信医保现金支付金额" width="100">
      </el-table-column>
      <el-table-column prop="wxybrefundpaynum" align="center" label="微信医保现金支付退费数量" width="80">
      </el-table-column>
      <el-table-column prop="wxybrefundpaymoney" align="center" label="微信医保现金支付退费金额" width="100">
      </el-table-column>
      <el-table-column prop="hispaynum" align="center" label="his支付订单数量" width="80">
      </el-table-column>
      <el-table-column prop="hispaymoney" align="center" label="his支付金额" width="100">
      </el-table-column>
      <el-table-column prop="hisrefnum" align="center" label="his退费数量" width="80">
      </el-table-column>
      <el-table-column prop="hisrefmoney" align="center" label="his退费金额" width="100">
      </el-table-column>
      <el-table-column prop="hismoney" align="center" label="his实收" width="100">
      </el-table-column>
      <el-table-column prop="wxmoney" align="center" label="微信实收" width="100">
      </el-table-column>
      <el-table-column prop="diffmoney" align="center" label="差值" width="80">
      </el-table-column>
      <el-table-column  prop="type" align="center" label="对账状态"  width="120">
        <template slot-scope="scope">
            <div v-show="scope.row.type == '一致'">一致</div>
            <div style="color: red;" v-show="scope.row.type == '异常'" @click="handleInfo(scope.row.dz_date)">异常</div>
        </template>
      </el-table-column>
      <el-table-column align="center" label="对账">
        <template slot-scope="scope">
            <el-button type="primary" size="mini" @click="goduizhang(scope.row.dz_date)">对 账</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <!-- 对账详情 -->

    <el-dialog :title="dzdate+'对账详情'" :visible.sync="dzinfoTableVisible" :fullscreen="true">
      <div class="biaoti">微信订单 </div>
      <el-table :data="infoData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中">
        <el-table-column align="center" type="index" width="40"></el-table-column>
        <el-table-column align="center" property="patient_realname" label="姓名" width="100"></el-table-column>
        <el-table-column align="center" property="trade_type" label="支付类型" width="140"></el-table-column>
        <el-table-column align="center" property="trade_state" label="支付状态" width="100"></el-table-column>
        <el-table-column align="center" property="actual_fee_total" label="金额" width="100"></el-table-column>
        <el-table-column align="center" property="weixin_transaction_id" label="订单号" width="210"></el-table-column>
        <el-table-column align="center" property="msg" label="说明"></el-table-column>
      </el-table>
      <div class="biaoti">医保订单 </div>
      <el-table :data="ybycorder" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" v-if="ybyc_length >0">
        <el-table-column align="center" type="index" width="40"></el-table-column>
        <el-table-column align="center" property="patient_realname" label="姓名" width="100"></el-table-column>

        <el-table-column align="center" property="ordstatus" label="支付状态" width="100">
            <template slot-scope="scope">
                <div v-show="scope.row.ordstatus == 6">支付成功</div>
                <div v-show="scope.row.ordstatus == 7">已退款</div>
                 <div v-show="scope.row.ordstatus == 5">单边账</div>

            </template>

        </el-table-column>
        <el-table-column align="center" property="ownpayamt" label="金额" width="100"></el-table-column>
        <el-table-column align="center" property="trade_no" label="订单号" width="210"></el-table-column>
        <el-table-column align="center" property="msg" label="说明"></el-table-column>
      </el-table>
    </el-dialog>
  </div>

</template>

<script>
  import Pagination from '../../components/Pagination'
  import { statement,statementInfo,duizhang  } from '../../api/payMG'
  export default {
    data() {
      return {
        loading: false, //是显示加载
        dzdate: '',
        formInline: {
          page: 1,
          limit: 10
        },
        // 分页参数
        pageparm: {
          currentPage: 1,
          pageSize: 10,
          total: 10
        },
        listData: [], //表格数据
        infoData: [], //对账详情
        dzinfoTableVisible : false,
        ybycorder:[],
        ybyc_length:0
      }
    },
    // 注册组件
    components: {
      Pagination
    },
    created(){
      this.getdata(this.formInline)
    },
    methods:{
      getdata(parameter) {
        this.loading = true
        statement(parameter).then(res => {
            this.loading = false
            this.listData = res.data
            // 分页赋值
            this.pageparm.currentPage = this.formInline.page
            this.pageparm.pageSize = this.formInline.limit
            this.pageparm.total = res.count
          }
        ).catch(err => {
           this.loading = false
           this.$message.error('数据加载失败，请稍后再试！')
         })
      },
      goduizhang(date) {
         this.loading = true
        const data = {date:date}
        duizhang(data).then(res => {
           this.loading = false
          if(res.code == 0){
            this.getdata(this.formInline)
            this.$message({
              type: 'success',
              message: res.msg
            })
          }else{
             this.loading = false
            this.$message.error(res.msg)
          }
        })
      },
      // 分页插件事件
      callFather(parm) {
        this.formInline.page = parm.currentPage
        this.formInline.limit = parm.pageSize
        this.getdata(this.formInline)
      },
      handleInfo(date){
        this.loading = true
        this.dzdate = date
        if(date && date != undefined){
          let parm = {date:date}
          statementInfo(parm).then(res => {
            console.log(res)
            this.loading = false
            this.dzinfoTableVisible = true
            this.infoData = res.order;

            this.ybycorder = res.yborder;
            this.ybyc_length = this.ybycorder.length
            console.log(this.ybycorder.length)
          });
        }
      }
    }
  }
</script>

<style>
  .biaoti{
    width: 100%;
    font-size: 16px;
    font-weight: bold;
    text-align: center;
    margin-top: 10px;
    margin-bottom: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/views/pay/Statement.vue